import React from "react";
import {Container, Heading} from "@chakra-ui/react";
import './Profiler.css'

function Profiler(props) {
    return (
        <Container
            className={'profiler'}
            minH={'sm'}
            borderRadius={24}
        >
            <Heading>
                MATRIX
            </Heading>
        </Container>
    );
}

export default Profiler;
